import { useIntl } from 'react-intl';
import { IconLanguage } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';

export type TranslationToggleProps = {
  visible: boolean;
  isActive: boolean;
  onToggle: () => void;
};

export const TranslationToggle = ({
  visible,
  isActive,
  onToggle,
}: TranslationToggleProps) => {
  const intl = useIntl();

  if (!visible) return null;

  return (
    <Tooltip
      title={intl.formatMessage({
        id: 'components.documentValidation.translation.toggleButton.tooltip',
      })}
    >
      <IconButton size="medium" color="secondary" onClick={onToggle}>
        <SvgIcon fontSize="medium" color={isActive ? 'success' : 'inherit'}>
          <IconLanguage />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
